// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__AdlPa","itemA":"Write_itemA__3PpGg","itemB":"Write_itemB__3sPQw","itemC":"Write_itemC__1OJID","itemD":"Write_itemD__32Hop"};